import React, { Component } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { Card, Radio, Divider, Select } from "antd";
const Option = Select.Option;
import FieldAggregation from "./analytics/field-agg";
import DateHistogram from "./analytics/date-histogram";
import { DonutChart, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { withChartData } from "../common/chart-data-hoc";
import { withChartConfig } from "../common/chart-config-hoc";
import { getCasesByField } from "../../services/api-reexam";
import { objectToSeries } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import * as Colors from "@unifiedpatents/euclid-react/lib/helpers/colors";

const COLOR_MAP = {
  "Decision - Certificate Issued": Colors.blue500,
  "Pending - Reexam Determination": Colors.blue400,
  "Pending - Reexam Ordered": Colors.blue300,
  "Pending - Preexam Processing": Colors.blue300,
  "Decision - Reexam Denied": Colors.grey400,
  "Decision - All Claims Cancelled": Colors.grey500,
  Other: Colors.orange200
};

class ReexamAnalytics extends Component {
  static propTypes = {
    filter: PropTypes.object
  };
  state = {
    fieldCategory: "requester",
    fieldDisplaySize: 20,
    fieldDate: "filing_date",
    fieldDrilldownDate: undefined
  };

  render() {
    const fieldAggOptions = [
      { value: "requester", label: "Requester" },
      { value: "owner", label: "Patent Owner" },
      { value: "law_firm", label: "Law Firm" },
      { value: "examiner_art_unit", label: "Art Unit" }
    ];
    const ChartByStatus = withChartConfig(withChartData(makeWidthFlexible(DonutChart), q => getCasesByField(q, "exparte_status"), this.props.filter));
    const helmet = {
      title: "Ex Parte Reexamination Analytics",
      meta: [{ name: "description", content: "Stats and charts for Ex Parte Reexamination Cases" }]
    };
    return (
      <Card bodyStyle={{ textAlign: "center", minHeight: 400 }}>
        <Helmet {...helmet} />
        <ChartByStatus title="Cases by Status" colorMap={COLOR_MAP} dataFormatter={objectToSeries} height={400} scrollable={false} />
        <Divider />
        <Radio.Group value={this.state.fieldCategory} onChange={e => this.setState({ fieldCategory: e.target.value })}>
          {fieldAggOptions.map((opt, i) => (
            <Radio.Button value={opt.value} key={i}>
              {opt.label}
            </Radio.Button>
          ))}
        </Radio.Group>
        <Divider type="vertical" />
        <Select
          value={this.state.fieldDisplaySize}
          placeholder="Display Size"
          onChange={val => this.setState({ fieldDisplaySize: val })}
          getPopupContainer={trigger => trigger.parentNode}
          style={{ width: 130 }}
        >
          <Option value={20}>{"Show Top 20"}</Option>
          <Option value={30}>{"Show Top 30"}</Option>
          <Option value={50}>{"Show Top 50"}</Option>
        </Select>
        <FieldAggregation field={this.state.fieldCategory} filter={this.props.filter} size={this.state.fieldDisplaySize} />
        <Divider />
        <Radio.Group value={this.state.fieldDate} onChange={e => this.setState({ fieldDate: e.target.value })}>
          <Radio.Button value="filing_date">{"Filing Date"}</Radio.Button>
          <Radio.Button value="application_status_date">{"Application Status Date"}</Radio.Button>
        </Radio.Group>
        <Divider type="vertical" />
        <Select
          value={this.state.fieldDrilldownDate}
          placeholder="Drill-Down By"
          onChange={val => this.setState({ fieldDrilldownDate: val })}
          getPopupContainer={trigger => trigger.parentNode}
          style={{ width: 180 }}
        >
          <Option value="">{"None"}</Option>
          <Option value="requester">{"Requester"}</Option>
          <Option value="owner">{"Patent owner"}</Option>
          <Option value="law_firm">{"Law Firm"}</Option>
          <Option value="examiner_art_unit">{"Art Unit"}</Option>
        </Select>
        <DateHistogram field={this.state.fieldDate} field2={this.state.fieldDrilldownDate} filter={this.props.filter} />
      </Card>
    );
  }
}

export default ReexamAnalytics;
